<script>
import { mapGetters } from 'vuex';
export default {
  name: 'FormPriceHeader',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['prices', 'formData']),
    permitText() {
      return this.formData.hasOwnPermit
        ? `<p class="all-incl-text pt-sm-10 pt-xs-10">
             <span class="all-incl-title block mb-5">BASIC PAKET - Wir kümmern uns um die Schilder, Sie um die Genehmigung</span>
            In dem Preis ist nur das <strong>Basic-Paket</strong>
             enthalten. Die Schilder für die Halteverbotszone werden geliefert, aufgestellt und nach Ablauf der Zone wieder abgeholt
           </p>`
        : `<p class="all-incl-text pt-sm-10 pt-xs-10">
             <span class="all-incl-title block mb-5">Alles Inklusive - Sie brauchen sich um nichts kümmern</span>
             In dem Preis ist die Beantragung der Genehmigung und die Genehmigungsgebühr enthalten. Sie erhalten somit ein
             <strong>Sorglos-Komplettpaket</strong>: Die Schilder für die Halteverbotszone werden geliefert, aufgestellt
             und nach Ablauf der Zone wieder abgeholt.
           </p>`;
    }
  },
  methods: {}
};
</script>

<template>
  <div class="form-details-price-header">
    <div class="clearfix row">
      <div class="col-md-3 pt-10" style="overflow-y: hidden;">
        <div class="panel panel-hv-price panel-default top-row">
          <div class="panel-heading">
            Unser Preis für Sie!
          </div>
          <div class="panel-body">
            <span class="hv-price"
            ><span id="gesamtsumme_sum" class="notranslate"> {{ prices ? prices.total : 0 | priceHeaderMoneyFormat }} €</span>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6 pl-md-5 pl-lg-5 all-incl-block" style="padding-top: 12px;">
        <div v-html="permitText"></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'FormPriceHeaderStyles';
</style>
